import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

function LanguageLocaleTable({ locales, onEdit, onDelete }) {
    return (
        <table className="app-table">
            <thead>
            <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Code</th>
                <th>Region Code</th>
                <th>Language</th>
                <th>Edit</th>
                <th>Delete</th>
            </tr>
            </thead>
            <tbody>
            {locales.map(locale => (
                <LocaleRow locale={locale} key={locale.id} onEdit={onEdit} onDelete={onDelete} />
            ))}
            </tbody>
        </table>
    );
}

function LocaleRow({ locale, onEdit, onDelete }) {
    return (
        <tr>
            <td>{locale.id}</td>
            <td>{locale.name}</td>
            <td>{locale.code}</td>
            <td>{locale.regionCode}</td>
            <td>{locale.language}</td>
            <td>
                <FaEdit className="edit-icon" onClick={() => onEdit(locale)} />
            </td>
            <td>
                <FaTrash className="delete-icon" onClick={() => onDelete(locale.id)} />
            </td>
        </tr>
    );
}

export default LanguageLocaleTable;
